var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8992 16L16.7584 22.1408C15.906 22.9713 14.7607 23.4327 13.5706 23.4249C12.3805 23.4172 11.2414 22.941 10.3998 22.0994C9.55826 21.2579 9.08206 20.1187 9.07431 18.9286C9.06657 17.7385 9.52791 16.5933 10.3584 15.7408L16.6827 9.41655C17.2485 8.85076 18.0159 8.5329 18.816 8.5329C19.6162 8.5329 20.3836 8.85076 20.9494 9.41655C21.5152 9.98235 21.833 10.7497 21.833 11.5499C21.833 12.35 21.5152 13.1174 20.9494 13.6832L14.8075 19.8251C14.5246 20.108 14.1409 20.2669 13.7408 20.2669C13.3408 20.2669 12.9571 20.108 12.6742 19.8251C12.3913 19.5422 12.2323 19.1585 12.2323 18.7584C12.2323 18.3583 12.3913 17.9747 12.6742 17.6918L18.6326 11.7334",
    stroke: "#5A5D64",
    strokeWidth: 1.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.e1b71b475bf9c83b4b56f6a37d458565.svg";
export { ForwardRef as ReactComponent };